import { render } from "./PlanPagos.vue?vue&type=template&id=b085e6d2"
import script from "./PlanPagos.vue?vue&type=script&lang=js"
export * from "./PlanPagos.vue?vue&type=script&lang=js"

import "./PlanPagos.vue?vue&type=style&index=0&id=b085e6d2&lang=scss"

import exportComponent from "/Volumes/Baguer/Develop/Quac/pagosquac-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__